import { type Icon } from 'react-bootstrap-icons';

import { DateParser } from '../../utils';

interface StatsCardProps {
  title: string;
  type: 'number' | 'date' | 'text';
  value: number | string | Date | undefined;
  icon?: Icon;
  iconColor?: string;
}

const StatsCard = ({ title, value, type, icon: IconComponent, iconColor }: StatsCardProps) => {
  const formatValue = (
    type: 'number' | 'date' | 'text',
    value: number | string | Date | undefined
  ): string => {
    if (value == null || value == undefined) {
      return '';
    }

    switch (type) {
      case 'date':
        return DateParser.toDateTimeString(new Date(value));
      case 'number':
        return Number(value).toLocaleString();

      case 'text':
        return String(value);

      default:
        return String(value);
    }
  };

  return (
    <div className="card h-100">
      <div className="card-body d-flex align-items-center py-4 px-3">
        <div className="d-flex align-items-center gap-3 mb-4 mt-auto">
          {IconComponent && (
            <div className="fs-2 text-primary">
              <IconComponent
                size={35}
                style={{
                  ...(iconColor != null && { color: iconColor })
                }}
              />
            </div>
          )}
          <div className="w-100">
            <div className="text-uppercase text-muted fw-semibold small mb-2">{title}</div>

            <div
              className={`fw-bold text-dark ${type === 'number' ? 'text-end' : ''}`}
              style={{ fontSize: '1.5rem' }}>
              {formatValue(type, value)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { StatsCard };
